import React from "react";
import { Popover, List, ListItemButton, ListItemText } from "@mui/material";
import { useGetExporterBankDetailsQuery } from "@/redux/ExportPage/CreateNewJob/General/GeneralPageapiSlice";
import { useUser } from "@/Context/UserContext";

export default function BankSelectorPopover({
  anchorEl,
  open,
  onClose,
  // bankList = [],
  onSelect,
}) {
  const { formData, setValueGlobal } = useUser();
  const exporterId = formData?.general?.exporterId?.id;

  // ✅ Correct usage of RTK Query
  const {
    data: bankList = [],
    isLoading,
    error,
  } = useGetExporterBankDetailsQuery({ id: exporterId }, { skip: !exporterId });

  const handleBankSelect = (bank) => {
    if (!bank) return;

    setValueGlobal("exportADCode", bank?.customeBankDealerADCode);
    setValueGlobal("exportAccountNumber", bank?.customeBankDealerACNo);

    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      PaperProps={{ sx: { width: 250, maxHeight: 300 } }}
    >
      <List>
        {bankList?.length === 0 ? (
          <ListItemButton disabled>
            <ListItemText primary="No bank available" />
          </ListItemButton>
        ) : (
          bankList.map((bank, idx) => (
            <ListItemButton key={idx} onClick={() => handleBankSelect(bank)}>
              <ListItemText
                primary={bank.customeBankDealerEntityName}
                secondary={bank.branch}
              />
            </ListItemButton>
          ))
        )}
      </List>
    </Popover>
  );
}
